import React, {useState} from 'react'

import UI5CheckBox from "../../../../../gd-ui/checkbox/checkbox"

type Props = {
    id          : ID
    title       : string

    selected?   : boolean
    onSelect?   : func
}
// const debug = "CopyOption"
const debug = false

export default function CopyOption(props:Props) {

    const [selected, setSelected] = useState(props.selected)

    const onSelect = () => {
        setSelected(!selected)
        if (props.onSelect) props.onSelect(props.id)
    }

    debug && console.log(debug, "props=" , props)

    return (
        <div className="copy-option">
            <UI5CheckBox className = "copy-option-checkbox"
                         isChecked = {selected}
                         onClick   = {onSelect}/>
            <div className="copy-option-title">{props.title}</div>
        </div>
    )
}